enum SplitFeature {
  NewDocumentMetadataApi = 'NEW_DOCUMENT_METADATA_API',
  ThirdPartyAccess = 'THIRD_PARTY_ACCESS',
}

export { SplitFeature };
